// API service for content management including YouTube videos for Enjoy Your Trips section
import { API_BASE_URL } from '../../config/api';

const contentManagementAPI = {
  // Get all content sections (admin view)
  getAllContentSections: async () => {
    const response = await fetch(`${API_BASE_URL}/content-sections/all`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch all content sections');
    }

    return response.json();
  },

  // Get active content sections (public view)
  getActiveContentSections: async () => {
    const response = await fetch(`${API_BASE_URL}/content-sections`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch active content sections');
    }

    return response.json();
  },

  // Get content section by ID
  getContentSectionById: async (id) => {
    const response = await fetch(`${API_BASE_URL}/content-sections/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch content section');
    }

    return response.json();
  },

  // Create new content section
  createContentSection: async (sectionData) => {
    const response = await fetch(`${API_BASE_URL}/content-sections`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(sectionData),
    });

    if (!response.ok) {
      throw new Error('Failed to create content section');
    }

    return response.json();
  },

  // Update content section
  updateContentSection: async (id, sectionData) => {
    const response = await fetch(`${API_BASE_URL}/content-sections/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(sectionData),
    });

    if (!response.ok) {
      throw new Error('Failed to update content section');
    }

    return response.json();
  },

  // Delete content section
  deleteContentSection: async (id) => {
    const response = await fetch(`${API_BASE_URL}/content-sections/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    });

    if (!response.ok) {
      throw new Error('Failed to delete content section');
    }

    return response.json();
  },

  // Update content section by type
  updateContentSectionByType: async (type, sectionData) => {
    const response = await fetch(`${API_BASE_URL}/content-sections/type/${type}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(sectionData),
    });

    if (!response.ok) {
      throw new Error('Failed to update content section by type');
    }

    return response.json();
  },

  // Get specific content section by type (e.g., 'enjoy_your_trips')
  getContentSectionByType: async (type) => {
    const response = await fetch(`${API_BASE_URL}/content-sections/type/${type}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        // Return a default structure when content section doesn't exist
        return {
          id: null,
          sectionName: type,
          content: { videos: [] },
          isActive: true,
          priority: 0,
          createdAt: null,
          updatedAt: null
        };
      } else {
        throw new Error(`Failed to fetch ${type} content section`);
      }
    }

    return response.json();
  },

  // Update or create content section for YouTube videos
  updateEnjoyYourTripsVideos: async (videos) => {
    const response = await fetch(`${API_BASE_URL}/content-sections/type/enjoy_your_trips`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        type: 'enjoy_your_trips',
        content: {
          videos: videos
        },
        isActive: true
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to update Enjoy Your Trips videos');
    }

    return response.json();
  },

  // Create or update content section for YouTube videos (using type update)
  createEnjoyYourTripsSection: async (videos) => {
    const response = await fetch(`${API_BASE_URL}/content-sections/type/enjoy_your_trips`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        type: 'enjoy_your_trips',
        content: {
          videos: videos
        },
        isActive: true
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to create/update Enjoy Your Trips section');
    }

    return response.json();
  }
};

export default contentManagementAPI;